module.exports = __webpack_public_path__ + "static/009.thumb-d324fcc8741497e019b0eadf7a2c4581.jpg";